import React from "react";
import { makeStyles } from "@material-ui/core";

let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        margin: '100px auto',
        flexWrap: 'wrap',
        minWidth: 1112,
        maxWidth: '100% !important',
        [theme.breakpoints.down("1200")]: {
            minWidth: '100%',
            flexDirection: 'column',
            margin: '0px auto',
        }
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    list: {
        listStyle: 'none',
    },
    icon: {
        width: 20,
        height: 25,
        minWidth: 20,
    },
    gridList: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
        [theme.breakpoints.down("600")]: {
            alignItems: 'center',
            marginBottom: 5,
            width: '90%',
            margin: 'auto'
        }
    },
    desc: {
        margin: "0px 10px",
        fontSize: 16,
    },
    content: {
        position: 'relative'
    },
    title: {
        textAlign: 'left',
        marginBottom: 10,
        fontSize: 28,
        [theme.breakpoints.down("600")]: {
            textAlign: 'center',
            fontSize: 25,
        }
    },
    girdImages: {
        width: '46%',
        maxWidth: '100%',
        [theme.breakpoints.down("1200")]: {
            marginBottom: '25px',
            width: '100%',
        },
        [theme.breakpoints.down("600")]: {
            '& img': {
                width: '100%',
            }
        }
    },
    girdContent: {
        width: '50%',
        // minWidth:600,
        maxWidth: '100% !important',
        [theme.breakpoints.down("1200")]: {
            minWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            textAlign: 'center',
        },

    },
}))

export default function Index() {

    let classes = useStyles();


    return (
        <div className={classes['root']}>
            <div className={classes['girdImages']}>
                <img src="/assets/images/newImages/image17.png" alt="" />
            </div>
            <div className={classes['girdContent']}>
                <div className={classes['content']}>
                    <div className={classes['line']} />
                    <h3 className={classes['title']}>
                        چرا در بورس سرمایه‌گذاری کنیم؟
                    </h3>
                    <ul className={classes['list']}>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    کسب سود
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    حمایت و شفافیت قانونی
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    حفظ سرمایه در مقابل تورم
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    سهولت در نقد شوندگی
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    عدم محدودیت در میزان سرمایه‌گذاری
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    مشارکت در اداره شرکت
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    بهره گیری از معافیت مالیاتی
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    تنوع بازه زمانی سرمایه‌گذاری
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className={classes['gridList']}>
                                <svg className={classes['icon']}>
                                    <use xlinkHref={'/sprit.svg#ok'}></use>
                                </svg>
                                <p className={classes['desc']}>
                                    سهولت سرمایه‌گذاری
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
